(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-gallery"] && !Shopify.designMode) return;
  try {
    
function setupLumijaGallery(root=document){root.querySelectorAll('.la-gallery').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';const dialog=gallery.querySelector('dialog'),image=dialog.querySelector('img'),caption=dialog.querySelector('p');gallery.querySelectorAll('[data-gallery-open]').forEach(button=>button.addEventListener('click',()=>{image.src=button.dataset.full;image.alt=button.dataset.caption;caption.textContent=button.dataset.caption;dialog.showModal();}));dialog.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});});}
setupLumijaGallery();document.addEventListener('shopify:section:load',event=>setupLumijaGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-styles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const trigger=event.target.closest('[data-style-open]');
  if(trigger){const dialog=document.getElementById(trigger.dataset.styleOpen);if(dialog&&!dialog.open){dialog.showModal();dialog.addEventListener('close',function(){trigger.focus();},{once:true});}}
  if(event.target.matches('dialog.la-style-dialog')){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom){event.target.close();}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumija-world"] && !Shopify.designMode) return;
  try {
    
  function observeLumijaFilms(root = document) {
    root.querySelectorAll('[data-lumija-film] video:not([data-observed])').forEach((video) => {
      video.dataset.observed = 'true';
      let manualPause = false;
      let internalPause = false;
      let visible = false;
      const toggle = video.closest('[data-lumija-film]').querySelector('[data-film-toggle]');
      const syncToggle = () => {
        if (!toggle) return;
        const label = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        toggle.setAttribute('aria-label', label);
        toggle.title = label;
        toggle.querySelector('span').textContent = video.paused ? '\u25b6' : '\u275a\u275a';
      };
      if (toggle) {
        video.controls = false;
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          if (video.paused) { manualPause = false; video.play().catch(syncToggle); }
          else { manualPause = true; video.pause(); }
        });
      }
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        if (visible && !document.hidden && !manualPause && !motion.matches && !navigator.connection?.saveData) {
          video.muted = true;
          video.play().catch(() => {});
        } else if (!video.paused) {
          internalPause = true;
          video.pause();
        }
      };
      video.addEventListener('pause', () => { if (!internalPause) manualPause = true; internalPause = false; syncToggle(); });
      video.addEventListener('play', () => { manualPause = false; syncToggle(); });
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting && entry.intersectionRatio >= 0.35; update(); }, { threshold: 0.35 });
      observer.observe(video);
      document.addEventListener('visibilitychange', update);
      motion.addEventListener('change', update);
      video.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        observer.disconnect(); document.removeEventListener('visibilitychange', update); motion.removeEventListener('change', update);
      }, { once: true });
    });
  }
  observeLumijaFilms();
  document.addEventListener('shopify:section:load', (event) => observeLumijaFilms(event.target));
  function updateLumijaCountdowns() {
    document.querySelectorAll('[data-lumija-countdown]').forEach((node) => {
      const date = new Date(node.dataset.lumijaCountdown);
      const remaining = date.getTime() - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) { node.hidden = true; return; }
      node.textContent = `${Math.ceil(remaining / 86400000)} ${node.dataset.label}`;
      node.hidden = false;
    });
  }
  updateLumijaCountdowns();
  document.addEventListener('shopify:section:load', updateLumijaCountdowns);
  setInterval(updateLumijaCountdowns, 60000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
